import { useSelector } from 'react-redux'
import { useOutletContext } from 'react-router-dom'

import { skipToken } from '@reduxjs/toolkit/query'
import { RTKQueryResultType } from 'source/js/data/baseApi'

import { Episode } from '@lyrahealth-inc/shared-app-logic/src/models/episodes/Episodes'

import { getSelectedClientId } from '../../../../data/lyraTherapy/clientSelectors'
import { useGetAllClientEpisodesQuery } from '../episodesApi'

type SelectedEpisodeResult = Omit<RTKQueryResultType<typeof useGetAllClientEpisodesQuery>, 'data'> & {
  data: Episode | undefined
}

export const useSelectedEpisodeForClient: (selectedEpisodeId?: string) => SelectedEpisodeResult = (
  selectedEpisodeId,
) => {
  const selectedClientId = useSelector(getSelectedClientId)

  // NOTE: outletContext is only available to outlets rendered within the client component, i.e., all the tabs
  // on the client home, use this hook with caution
  const { clientDetailsSelectedEpisodeId }: { clientDetailsSelectedEpisodeId?: string } = useOutletContext() ?? {}

  const episodeIdToFilter = clientDetailsSelectedEpisodeId || selectedEpisodeId

  return useGetAllClientEpisodesQuery(
    selectedClientId && episodeIdToFilter ? { patientId: selectedClientId } : skipToken,
    {
      selectFromResult: ({ data: episodes, isLoading, ...rest }) => ({
        data: episodes?.find((episode) => episode.id === episodeIdToFilter),
        isLoading,
        ...rest,
      }),
    },
  ) as SelectedEpisodeResult
}
